// Contact form types and payload shaping for the browser. Field rules live in
// the form (react-hook-form); the server re-validates everything with zod
// (server/validators.ts), so zod no longer ships to the browser.

// "Contact me about" options per Website Review — multi-select, Other opens
// a free-text message with no practical character limit.
export const CONTACT_TOPICS = [
  'Partnership Interest',
  'Sign up for updates',
  'Share resources',
  'Other',
] as const

export type ContactTopic = (typeof CONTACT_TOPICS)[number]

export interface ContactInput {
  name: string
  email: string
  organization?: string
  topics: ContactTopic[] | ContactTopic | false
  message?: string
  /** Honeypot — bots fill this; humans never see it. */
  website?: string
}

export interface ContactPayload {
  name: string
  email: string
  organization?: string
  topics: ContactTopic[]
  message?: string
  website?: string
}

/** Trim fields, drop empty optionals, normalize the checkbox group to an array. */
export function toContactPayload(values: ContactInput): ContactPayload {
  const topics = Array.isArray(values.topics) ? values.topics : values.topics ? [values.topics] : []
  const optional = (v?: string) => {
    const t = v?.trim()
    return t ? t : undefined
  }
  return {
    name: values.name.trim(),
    email: values.email.trim(),
    organization: optional(values.organization),
    topics,
    message: topics.includes('Other') ? optional(values.message) : undefined,
    website: values.website ?? '',
  }
}
